export const footerMoreLinks = {
  'es-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'es-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.es/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.es/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://www.wingie.es/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.es/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.es/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.es/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'es-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.es/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.es/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.es/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.es/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.es/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.es/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'es-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.es/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.es/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.es/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.es/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.es/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.es/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'es-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.es/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.es/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.es/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.es/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.es/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.es/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'es-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://www.wingie.es/it/contact/', title: 'Contatto' },
        // { href: 'https://www.wingie.es/it/faq/', title: 'Domande frequenti' },

        { href: 'https://www.wingie.es/it/about-us/', title: 'Chi siamo' },
        { href: 'https://www.wingie.es/it/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.es/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://www.wingie.es/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'es-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://www.wingie.es/fr/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.es/fr/faq/', title: 'Questions fréquemment posées' },

        { href: 'https://www.wingie.es/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://www.wingie.es/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://www.wingie.es/fr/terms-and-conditions/', title: 'Termes et conditions' },
        { href: 'https://www.wingie.es/fr/awards/', title: 'Nos récompenses' },
      ],
    },
  ],
  'es-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.es/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.es/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://www.wingie.es/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.es/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.es/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.es/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'es-ro': [
    {
      title: 'Mai multe',
      items: [
        { href: 'https://www.wingie.es/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.es/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://www.wingie.es/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.es/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.es/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.es/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'es-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://www.wingie.es/pl/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.es/pl/faq/', title: 'Często zadawane pytania' },

        { href: 'https://www.wingie.es/pl/about-us/', title: 'O nas' },
        { href: 'https://www.wingie.es/pl/privacy/', title: 'Prywatność' },
        { href: 'https://www.wingie.es/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://www.wingie.es/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'es-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.es/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.es/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://www.wingie.es/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.es/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.es/lt/terms-and-conditions/', title: 'Sąlygos' },
        { href: 'https://www.wingie.es/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'es-uz': [
    {
      title: 'Boshqa',
      items: [
        { href: 'https://www.wingie.es/uz/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.es/uz/faq/', title: "Ko'p beriladigan savollar" },

        { href: 'https://www.wingie.es/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.es/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.es/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.es/uz/awards/', title: 'Bizning mukofotlar' },
      ],
    },
  ],
  'es-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.es/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.es/sr/faq/', title: 'Често постављана питања' },

        { href: 'https://www.wingie.es/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.es/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.es/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.es/sr/awards/', title: 'Наше награде' },
      ],
    },
  ],
  'es-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.es/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.es/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://www.wingie.es/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.es/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.es/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.es/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'es-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.es/tg/contact/', title: 'Тамос' },
        // { href: 'https://www.wingie.es/tg/faq/', title: 'Саволҳои зиёд додашаванда' },

        { href: 'https://www.wingie.es/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.es/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.es/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.es/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'es-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.es/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.es/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://www.wingie.es/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.es/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://www.wingie.es/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.es/kk/awards/', title: 'Біздің марапаттар' },
      ],
    },
  ],
  'es-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.es/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.es/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://www.wingie.es/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.es/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.es/nl/terms-and-conditions/', title: 'Voorwaarden' },
        { href: 'https://www.wingie.es/nl/awards/', title: 'Onze prijzen' },
      ],
    },
  ],
  'es-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.es/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.es/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.es/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.es/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.es/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.es/ja/awards/' },
      ],
    },
  ],
  'es-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.es/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.es/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.es/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.es/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.es/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.es/zh/awards/' },
      ],
    },
  ],
  'es-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.es/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.es/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.es/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.es/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.es/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.es/ko/awards/' },
      ],
    },
  ],
  'es-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.es/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.es/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.es/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.es/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.es/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.es/hi/awards/' },
      ],
    },
  ],
  'es-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.es/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.es/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.es/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.es/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.es/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.es/ta/awards/' },
      ],
    },
  ],
  'es-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.es/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.es/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.es/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.es/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.es/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.es/th/awards/' },
      ],
    },
  ],
  'es-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.es/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.es/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.es/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.es/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.es/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.es/ur/awards/' },
      ],
    },
  ],
  'es-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.es/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.es/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.es/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.es/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.es/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.es/ka/awards/' },
      ],
    },
  ],
}
